import { IppicaInPartenzaItem } from 'components/ippicaInPartenzaItem';
import { Skeleton } from 'components/skeleton';
import { Wrapper } from 'components/wrapper';
import { useGetCorseIppicaInPartenzaQuery } from 'features/api/ippicaApiSlice';
import { IppicaEmpty } from 'features/ippica/components/ippicaEmpty/IppicaEmpty';
import { setCurrentTime } from 'features/ippica/ippicaSlice';
import { selectCodiceRiunione } from 'features/ippica/selectors';
import { useHideNavigationCarousel } from 'hooks';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';
import { useEffect, useRef } from 'react';
import { FreeMode, Mousewheel, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { breakpoint } from 'utility/constant';
import styles from './IppicaInPartenza.module.scss';

export type IppicaInPartenzaProps = {
  label: string;
};
export const IppicaInPartenza = ({ label }: IppicaInPartenzaProps) => {
  const dispatch = useAppDispatch();
  const swiperRef = useRef<any>(null);
  const codiceRiunione = useTypedSelector(selectCodiceRiunione);
  const { data: ippicaInPartenzaResponse, isLoading } = useGetCorseIppicaInPartenzaQuery(codiceRiunione ?? undefined);
  const { isScrollable, swiperSlideRef } = useHideNavigationCarousel({
    className: 'disabled',
    items: [ippicaInPartenzaResponse ? ippicaInPartenzaResponse : []],
  });

  useEffect(() => {
    const intervalId = setInterval(() => {
      dispatch(setCurrentTime());
    }, 1000);
    return () => clearInterval(intervalId); // Cancella l'intervallo quando il componente viene smontato
  }, [dispatch]);

  return !ippicaInPartenzaResponse?.length ? null : isLoading || !ippicaInPartenzaResponse ? (
    <Skeleton />
  ) : (
    <Wrapper
      noPaddingTop
      noPaddingLeft
      noPaddingRight
      bgColorTransparent
      className={`${!!ippicaInPartenzaResponse?.length ? 'ippicaBackground' : 'ippicaBackgroundNoContent'}`}
      classNameWrapper={`${codiceRiunione ? styles.prossimeCorseWrapper : ''}`}
    >
      <h2 className={styles.title}>{label}</h2>
      <div className={styles.container}>
        <Swiper
          onInit={(core) => (swiperSlideRef.current = core.el)}
          spaceBetween={16}
          grabCursor
          slidesPerView={'auto'}
          slidesOffsetBefore={20}
          slidesOffsetAfter={20}
          modules={[Navigation, FreeMode, Mousewheel]}
          updateOnWindowResize
          watchOverflow
          freeMode={{
            enabled: true,
            minimumVelocity: 0.2,
          }}
          mousewheel={{ forceToAxis: true }}
          navigation={isScrollable && !!ippicaInPartenzaResponse?.length ? true : false}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          breakpoints={{
            [breakpoint.md]: {
              grabCursor: false,
              slidesOffsetBefore: 24,
              slidesOffsetAfter: 32,
              simulateTouch: false,
              allowTouchMove: false,
            },
            [breakpoint.lg]: {
              slidesOffsetBefore: 24,
              slidesOffsetAfter: 40,
            },
          }}
        >
          {ippicaInPartenzaResponse.map((item, index) => {
            return (
              <SwiperSlide key={index}>
                <IppicaInPartenzaItem item={item} />
              </SwiperSlide>
            );
          })}
          {!ippicaInPartenzaResponse?.length && (
            <IppicaEmpty hasMarginRight={true}>
              <span>Non ci sono corse in partenza</span>
            </IppicaEmpty>
          )}
        </Swiper>
      </div>
    </Wrapper>
  );
};
